module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight-0401447462f8f7056448bbc6506ed1a8.png";